import type { DealProductBuilderRow, ForwardDealProductBuilderRow } from '@src/types/OTC';
import { otcForwardFieldDefinitions } from '@src/utils/OTC/otcForwardFieldDefinitions';
import { getColumnTitle, getColumnTooltip } from '@src/utils/fieldDefinitionUtils';
import type { useDisclosureWithContext } from '@talos/kyoko';
import { useMemo } from 'react';
import { useDealProductBuilderAssets } from '../DealProductBuilderAssetsProvider';
import type { DealProductBuilderColumn } from '../dealProductBuilderColDef';
import { DealProductBuilderGrid } from './DealProductBuilderGrid';
import { buildCurrencySelectorColumn } from './baseProductBuilderColumns';

interface ForwardProductBuilderGridProps {
  panelID: string;
  productDetailsDisclosure: ReturnType<
    typeof useDisclosureWithContext<{ rowIndex: number; rowData: DealProductBuilderRow }>
  >;
}
export const ForwardProductBuilderGrid = ({ panelID, productDetailsDisclosure }: ForwardProductBuilderGridProps) => {
  const { availableUnderlyingAssets } = useDealProductBuilderAssets();

  const customColumns = useMemo(() => {
    return [
      buildCurrencySelectorColumn<ForwardDealProductBuilderRow>({
        key: 'baseAsset',
        headerName: getColumnTitle(otcForwardFieldDefinitions.underlying),
        currenciesToInclude: availableUnderlyingAssets,
        description: getColumnTooltip(otcForwardFieldDefinitions.underlying) ?? '',
      }),
    ] as DealProductBuilderColumn[];
  }, [availableUnderlyingAssets]);

  return (
    <DealProductBuilderGrid
      panelID={panelID}
      productDetailsDisclosure={productDetailsDisclosure}
      customColumnDefs={customColumns}
      fieldDefinitions={otcForwardFieldDefinitions}
    />
  );
};
